import { getInfluxdbData } from "../api/influxdb-tools";

/* Production modes */
export const PRODUCTION_MODE_SIMPLE = 0; // no patterns/no specific stuff
export const PRODUCTION_MODE_FULL = 1; // full
export const PRODUCTION_MODE_DEMO = 2; // demo
export const PRODUCTION_MODE_CUSTOMER = 3; // customer specific

/* Display options */
export const JOURNAL_DISPLAY_ALL = 1;
export const JOURNAL_DISPLAY_PATTERNS_ONLY = 2;
export const JOURNAL_DISPLAY_ALERTS_ONLY = 3;
export const JOURNAL_DISPLAY_NON_CONFORMITY_ONLY = 4;

export const JOURNAL_DISPLAY_OPTIONS = [
  { id: JOURNAL_DISPLAY_ALL, name: 'TOUT AFFICHER' },
  { id: JOURNAL_DISPLAY_PATTERNS_ONLY, name: 'ARTICLES UNIQUEMENT' },
  { id: JOURNAL_DISPLAY_ALERTS_ONLY, name: 'ALERTES UNIQUEMENT' },
  { id: JOURNAL_DISPLAY_NON_CONFORMITY_ONLY, name: 'NON CONFORMITES UNIQUEMENT' },
];

export const getLogs = async (subtypes, startTimestamp, stopTimestamp) => {
  const startDate = new Date(startTimestamp);
  const stopDate = new Date(stopTimestamp);

  const start = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString();
  const stop = new Date(stopDate.getTime() - stopDate.getTimezoneOffset() * 60000).toISOString();

  return await getInfluxdbData(
    'engine',
    'events',
    [],
    ['type', 'duration', ['subtype', '==', subtypes], 'data_'],
    start,
    stop,
    '1ms',
    null,
    null,
    [],
    null,
    null,
    false,
    'desc',
  );
};